// import React from 'react';

const CoreFeatures = () => {
  const coreFeaturesData = [
    {
      icon: (
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="64" height="64" rx="32" fill="#7A57F4" />
          <path
            d="M31.9983 35.6667C33.0166 35.6667 33.8824 35.3103 34.596 34.5977C35.3098 33.885 35.6667 33.0197 35.6667 32.0017C35.6667 30.9835 35.3103 30.1176 34.5977 29.404C33.885 28.6902 33.0197 28.3333 32.0017 28.3333C30.9834 28.3333 30.1176 28.6897 29.404 29.4023C28.6902 30.115 28.3333 30.9803 28.3333 31.9983C28.3333 33.0166 28.6897 33.8825 29.4023 34.596C30.115 35.3098 30.9803 35.6667 31.9983 35.6667ZM24 41.3333H40V41.0307C40 40.7165 39.9333 40.4247 39.8 40.1553C39.6667 39.886 39.4709 39.6692 39.2127 39.505C38.1324 38.7821 36.9798 38.2309 35.7547 37.8513C34.5296 37.4718 33.2652 37.282 31.9617 37.282C30.6728 37.282 29.4228 37.4739 28.2117 37.8577C27.0006 38.2415 25.8608 38.7952 24.7923 39.519C24.5308 39.6823 24.3333 39.8987 24.2 40.168C24.0667 40.4376 24 40.7295 24 41.0437V41.3333ZM22 43.3333V28.3333L32 20.8207L42 28.3333V43.3333H22Z"
            fill="white"
          />
        </svg>
      ),
      title: 'Resident Management',
      description:
        ' Easily manage residents with a centralized system track profiles, lease details, and communication in one place for better organization and efficiency.',
    },
    {
      icon: (
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="64" height="64" rx="32" fill="#357AE1" />
          <g clip-path="url(#clip0_452_70055)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M52.7442 32.655C52.7442 29.7577 51.3408 27.4715 48.6585 27.4715C45.9648 27.4715 44.3351 29.7577 44.3351 32.6324C44.3351 36.0391 46.2591 37.7594 49.0206 37.7594C50.3674 37.7594 51.3861 37.4538 52.1556 37.0237V34.7601C51.386 35.1449 50.5033 35.3826 49.3828 35.3826C48.2849 35.3826 47.3116 34.9978 47.1871 33.6623H52.7215C52.7216 33.5151 52.7442 32.9266 52.7442 32.655ZM47.1532 31.5798C47.1532 30.3008 47.9342 29.7689 48.6472 29.7689C49.3376 29.7689 50.0732 30.3008 50.0732 31.5798H47.1532ZM39.9664 27.4715C38.8572 27.4715 38.1442 27.992 37.748 28.3543L37.6009 27.6526H35.111V40.8492L37.9405 40.2494L37.9518 37.0464C38.3592 37.3407 38.959 37.7594 39.955 37.7594C41.9809 37.7594 43.8257 36.1297 43.8257 32.5419C43.8145 29.2597 41.947 27.4715 39.9664 27.4715ZM39.2873 35.2694C38.6195 35.2694 38.2234 35.0318 37.9518 34.7375L37.9405 30.5385C38.2347 30.2103 38.6422 29.984 39.2873 29.984C40.3172 29.984 41.0302 31.1384 41.0302 32.621C41.0303 34.1376 40.3285 35.2694 39.2873 35.2694ZM31.2177 26.8037L34.0585 26.1925V23.895L31.2177 24.4949V26.8037ZM31.2177 27.6638H34.0585V37.5669H31.2177V27.6638ZM28.1732 28.5013L27.9921 27.6638H25.5475V37.5669H28.3769V30.8554C29.0446 29.9839 30.1764 30.1424 30.5273 30.2669V27.6638C30.1651 27.528 28.8409 27.279 28.1732 28.5013ZM22.5143 25.2079L19.7527 25.7964L19.7414 34.8619C19.7414 36.537 20.9977 37.7707 22.6727 37.7707C23.6008 37.7707 24.2798 37.6008 24.6534 37.3971V35.0996C24.2912 35.2468 22.503 35.7673 22.503 34.0924V30.0745H24.6534V27.6639H22.503L22.5143 25.2079ZM14.8634 30.5385C14.8634 30.0971 15.2256 29.9274 15.8254 29.9274C16.6856 29.9274 17.7721 30.1877 18.6323 30.6518V27.992C17.6929 27.6186 16.7648 27.4715 15.8254 27.4715C13.5279 27.4715 12 28.6711 12 30.6744C12 33.7981 16.3008 33.3001 16.3008 34.6469C16.3008 35.1676 15.8481 35.3373 15.2143 35.3373C14.2749 35.3373 13.0752 34.9525 12.1245 34.4319V37.1255C13.1771 37.5782 14.241 37.7707 15.2143 37.7707C17.5684 37.7707 19.1869 36.6049 19.1869 34.5791C19.1756 31.2063 14.8634 31.8062 14.8634 30.5385Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_452_70055">
              <rect
                width="40.7442"
                height="40.7442"
                fill="white"
                transform="translate(12 12)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      title: 'Instant Payments',
      description:
        ' Simplify financial operations with secure, real-time digital payments. Collect rent, fees, and other charges instantly, reducing delays and manual work.',
    },
    {
      icon: (
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="64" height="64" rx="32" fill="#24C661" />
          <path
            d="M22.5 40.5V39H41.5V40.5H22.5ZM23.5 37.6152V31.5H26V37.6152H23.5ZM28.327 37.6152V26.5H30.827V37.6152H28.327ZM33.1635 37.6152V29.5H35.6635V37.6152H33.1635ZM38 37.6152V23.5H40.5V37.6152H38Z"
            fill="white"
          />
        </svg>
      ),
      title: 'Reporting & Transparency',
      description:
        'Gain full visibility with detailed reports and analytics. Track finances, operations, and resident activity, ensuring transparency for owners and stakeholders.',
    },
  ];
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex items-center justify-center p-8">
      <div className="max-w-7xl w-full">
        {/* Header */}
        <div className="text-center mb-8 lg:mb-16">
          <h1 className="text-2xl md:text-5xl font-bold text-gray-900 mb-4">
            Core features
          </h1>
          <p className="text-base md:text-xl text-gray-600 max-w-2xl mx-auto">
            The essentials that power seamless management and growth.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8">
          {coreFeaturesData.map((feature) => (
            <div className="bg-white rounded-2xl p-4 md:p-8 shadow-md hover:shadow-md transition-shadow">
              <div className="mb-4 md:mb-12">{feature.icon}</div>
              <h2 className="text-lg md:text-2xl font-bold text-primary mb-2 md:mb-4">
                {feature.title}
              </h2>
              <p className="text-secondary leading-relaxed text-sm md:text-lg">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CoreFeatures;
